import { render, staticRenderFns } from "./StandardReleaseInformation.vue?vue&type=template&id=cd64ee32"
import script from "./StandardReleaseInformation.vue?vue&type=script&lang=js"
export * from "./StandardReleaseInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports